import TripsFilter from "./tripsFilter/tripsFilter";
import TripsList from "./tripsList/tripsList";
import Pagination from "../../../shared/pagination/pagination";

import './allTrips.css';

const AllTrips = (
    {
        trips,
        tripsLoader,
        tripError,
        pagination,
        onPageChange
    }) => {
    return (
        <div className={'trips-section flex gap-0 align-top hr-space-between'}>
            <div className="page-filter-sec">
                <TripsFilter/>
            </div>
            {!tripError &&
                <div className={'trips-table page-fade-in'}>
                    <div className="margin-b-30">
                        <div className="search-box margin-b-30 drivers-search round-corner-8">
                            <input type="text" placeholder={'Search'}/>
                        </div>
                        <div className="sf-medium font-17">List View</div>
                    </div>
                    <div className="margin-b-50">
                        <TripsList data={trips} tripsLoader={tripsLoader}/>
                    </div>
                    <div className="">
                        {trips?.length > 0 &&
                            <Pagination pages={pagination?.pageCount}
                                        pagination={pagination}
                                        currentPage={pagination?.currentPage}
                                        onPageChange={onPageChange}/>}
                    </div>
                </div>
            }
            {tripError &&
                tripError.map((error, index) =>
                    <div key={index} className={'trips-table'}>
                        <div className={'error-color text-align-center margin-b-20'}>{error.message}</div>
                    </div>
                )
            }
        </div>
    )
}

export default AllTrips;
